import { createAction, props } from '@ngrx/store';

import { ClientListActionTypes } from './types';

export const init = createAction(ClientListActionTypes.Init);

export const listViewTypeChanged = createAction(
  ClientListActionTypes.ListViewTypeChanged,
  props<{ viewType: string }>()
);

export const viewMoreClicked = createAction(
  ClientListActionTypes.ViewMoreClicked
);

export const filtersChanged = createAction(
  ClientListActionTypes.FiltersChanged,
  props<{ filters: Record<string, unknown> }>()
);
